import { Controller } from "@hotwired/stimulus";
import { phoneNumberFormatter } from "../application/phoneNumberFormatter.js";

export default class InvestorCategoryStepController extends Controller {
  static targets = [
    "professionalLegalInvestorByNature",
    "professionalLegalInvestor",
    "notProfessionalLegalInvestor",
    "professionalLegalInvestorByNatureBlock",
    "professionalLegalInvestorBlock",
    "nonFinancialEntityBlock",
    "firstSignerPhoneNumber",
    "firstSignerPhoneNumberError",
    "secondSignerPhoneNumber",
    "secondSignerPhoneNumberError",
    "naturalInvestor30k",
    "naturalInvestor30kBlock",
    "legalInvestor30k",
    "legalInvestor30kBlock",
  ];

  connect() {
    this.toggleBlocks();
    this.toggleNaturalBlocks();

    if (this.hasFirstSignerPhoneNumberTarget) {
      phoneNumberFormatter(this.firstSignerPhoneNumberTarget, this.firstSignerPhoneNumberErrorTarget);
      phoneNumberFormatter(this.secondSignerPhoneNumberTarget, this.secondSignerPhoneNumberErrorTarget);
    }
  }

  toggleNaturalBlocks() {
    if (!this.hasNaturalInvestor30kTarget) return;

    if (this.naturalInvestor30kTarget.checked) {
      this.naturalInvestor30kBlockTarget.classList.remove("d-none");
    } else {
      this.naturalInvestor30kBlockTarget.classList.add("d-none");
      this.naturalInvestor30kBlockTarget
        .querySelectorAll('input[type="radio"]')
        .forEach((r) => (r.checked = false));
    }
  }

  toggleBlocks() {
    if (!this.hasProfessionalLegalInvestorTarget) return;

    const isProBySize = this.professionalLegalInvestorTarget.checked;
    const isProByNature = this.professionalLegalInvestorByNatureTarget.checked;
    const is30k = this.hasLegalInvestor30kTarget && this.legalInvestor30kTarget.checked;
    const isNotPro = this.hasNotProfessionalLegalInvestorTarget && this.notProfessionalLegalInvestorTarget.checked;

    this.professionalLegalInvestorBlockTarget.classList.toggle("d-none", !isProBySize);
    this.professionalLegalInvestorByNatureBlockTarget.classList.toggle("d-none", !isProByNature);
    this.nonFinancialEntityBlockTarget.classList.toggle("d-none", !(isProBySize || isNotPro));

    if (this.hasLegalInvestor30kBlockTarget) {
      this.legalInvestor30kBlockTarget.classList.toggle("d-none", !is30k);
    }
  }
}
